module.exports = __webpack_public_path__ + "img/loader.7017f1a9.svg";